import { getFirestore } from '../../system/firebase';
import { getFullNameByUser } from '../textHelper';

import _get from 'lodash/get';
import _filter from 'lodash/filter';
import _includes from 'lodash/includes';
import _toLower from 'lodash/toLower';
import _sortBy from 'lodash/sortBy';
import _some from 'lodash/some';
import { USER_TYPE_JS } from '../constants';

//TODO Change temporary filtering to Elastic Search query
export const loadSimpleLovs = async ({ lovName } = {}) => {
    const db = getFirestore();
    const lovQuery = db.collection(lovName).limit(100);
    const list = [];

    try {
        const querySnapshot = await lovQuery.get();
        querySnapshot.forEach(lovDoc => {
            const data = lovDoc.data();
            const item = _get(data, 'name');
            list.push(item);
        });

        return _sortBy(list);
    } catch (error) {
        console.log(`loadSimpleLovs - Error fetching ${lovName} options.`);
        throw error;
    }
};

//TODO Change temporary filtering to Elastic Search query
export const getSimpleCreatableLovOptions = async ({ lovName, keywordList = [] } = {}) => {
    const db = getFirestore();
    const lovQuery = db.collection(lovName).limit(100);
    const list = [];

    try {
        const querySnapshot = await lovQuery.get();
        querySnapshot.forEach(lovDoc => {
            const data = lovDoc.data();
            const industry = _get(data, 'name');
            list.push(industry);
        });

        if (keywordList.length > 0) {
            const filteredList = _filter(list, item => {
                return _some(keywordList, keyword => _includes(_toLower(item), _toLower(keyword)));
            });
            return _sortBy(filteredList);
        } else {
            return _sortBy(list);
        }
    } catch (error) {
        console.error(`getSimpleCreatableLovOptions - Error fetching ${lovName} options.`);
        throw error;
    }
};

export const getIndustryOptions = async ({ keywordList = [] } = {}) => {
    return getSimpleCreatableLovOptions({ lovName: 'industries', keywordList });
};

export const getOccupationOptions = async ({ keywordList = [] } = {}) => {
    return getSimpleCreatableLovOptions({ lovName: 'occupations', keywordList });
};

export const getOtherEducationOptions = async ({ keywordList = [] } = {}) => {
    return getSimpleCreatableLovOptions({ lovName: 'otherEducations', keywordList });
};

export const getSkillSetOptions = async ({ keywordList = [] } = {}) => {
    return getSimpleCreatableLovOptions({ lovName: 'skillSets', keywordList });
};

//TODO Change temporary filtering to Elastic Search query
export const getLocationOptions = async ({ keywordList = [] } = {}) => {
    const db = getFirestore();
    const stateRef = db.collection('app').doc('lovs').collection('countries').doc('united states').collection('states').doc('california');

    try {
        const stateDoc = await stateRef.get();
        if (stateDoc.exists) {
            const data = stateDoc.data();
            const list = _get(data, 'cityList');
            if (keywordList.length > 0) {
                const filteredList = _filter(list, item => {
                    const name = item.name;
                    return _some(keywordList, keyword => _includes(_toLower(name), _toLower(keyword)));
                });
                return _sortBy(filteredList);
            } else {
                return _sortBy(list);
            }
        } else {
            return [];
        }
    } catch (error) {
        console.error('Error fetching Location options.');
        throw error;
    }
};

//TODO Change temporary filtering to Elastic Search query
export const getJobSeekersOptions = async ({ keywordList = [] } = {}) => {
    const db = getFirestore();
    const jobSeekersQuery = db.collection('users').where('type', '==', USER_TYPE_JS);

    try {
        const list = [];
        const jobSeekersSnapshot = await jobSeekersQuery.get();
        jobSeekersSnapshot.forEach(jobSeekerDoc => {
            list.push(jobSeekerDoc.data());
        });

        if (keywordList.length > 0) {
            const filteredList = _filter(list, item => {
                const name = getFullNameByUser(item);
                return _some(keywordList, keyword => _includes(_toLower(name), _toLower(keyword)));
            });
            return filteredList;
        } else {
            return list;
        }
    } catch (error) {
        console.error('Error fetching Job Seeker options.');
        throw error;
    }
};

//TODO Change temporary filtering to Elastic Search query
export const getJobsOptionsByEmployerId = async ({ employerId, keywordList = [] } = {}) => {
    const db = getFirestore();
    const jobsQuery = db.collection('jobs').where('employerId', '==', employerId).where('active', '==', true);

    try {
        const list = [];
        const jobsSnapshot = await jobsQuery.get();
        jobsSnapshot.forEach(jobDoc => {
            list.push(jobDoc.data());
        });

        if (keywordList.length > 0) {
            const filteredList = _filter(list, item => {
                return _some(keywordList, keyword => _includes(_toLower(item.jobTitle), _toLower(keyword)));
            });
            return filteredList;
        } else {
            return list;
        }
    } catch (error) {
        console.error('Error fetching Jobs options.');
        throw error;
    }
};
